import { marketingAPIBase } from 'app/utilities/env';
import axios, { AxiosResponse } from 'axios';

import { TContactUsDTO, TContactUsServerResponse } from '../types';

const axiosInstance = axios.create({ baseURL: marketingAPIBase });

export const contactUsAPIRequest = async (data: TContactUsDTO) => {
  const response: AxiosResponse<TContactUsServerResponse> =
    await axiosInstance.post('/tickets', data);
  return response.data;
};
